import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Consts } from "../../pages/consts";

const TimeIntake = ({ index, intake, onSetIntake }) => {
  const { t: t } = useTranslation();
  const [intakeTime, setIntakeTime] = useState("");
  const [dosage, setDosage] = useState("");

  const handleChangeDosage = (e) => {
    setDosage(e.target.value);
    onSetIntake({...intake, dosage: e.target.value}, index);
  }

  const handleChangeIntakeTime = (e) => {
    setIntakeTime(e.target.value);
    onSetIntake({...intake, intakeTime: e.target.value}, index);
  }

  return (
    <div className="w3-row w3-padding-small">
      <div className="w3-col s2">
        <label>{t("dosage")}*</label>
      </div>
      <div className="w3-col s2">
        <input
          value={dosage}
          type={Consts.NUMBER}
          min="1"
          onChange={(e) => handleChangeDosage(e)}
          className="form-input"
        />
      </div>
      <div className="w3-col s3">
        <label className="label-margin-left">{t(intake?.dosageUnit?.dosageUnit)}</label>
      </div>
      <div className="w3-col s2">
        <label>{t("time")}:</label>
      </div>
      <div className="w3-col s3">
        <input
          value={intakeTime}
          type={Consts.TIME}
          className="form-input"
          onChange={(e) => handleChangeIntakeTime(e)}
        />
      </div>
    </div>
  );
};

export default TimeIntake;
